import React from 'react';
import { Link } from 'react-router-dom';
import { GOLD, GOLD_LT, CREAM } from '../theme';

// The homepage sold the look but never the service. For a made-to-measure
// house the process *is* the product — it is what justifies booking an
// appointment instead of buying off a rack — and it was buried on /about.
const PILLARS = [
  {
    n: '01',
    t: 'Hand Embroidery',
    d: 'Every motif is placed by hand. A single bridal lehenga takes weeks on the frame before it ever reaches a fitting.',
  },
  {
    n: '02',
    t: 'Made to Measure',
    d: 'Nothing leaves the atelier off a rack. Each piece is cut to you, with fittings along the way to get it right.',
  },
  {
    n: '03',
    t: 'Heirloom Technique',
    d: 'Our karigars carry methods passed down through generations of Islamabad ateliers — the same hand, one generation on.',
  },
];

export default function AtelierPromise() {
  return (
    <section
      style={{ padding: 'clamp(64px,10vh,130px) clamp(20px,4vw,60px)', background: 'linear-gradient(180deg,#180b0a 0%,#16110c 100%)', borderTop: '1px solid rgba(201,162,75,.2)' }}
    >
      <div style={{ maxWidth: 620, marginBottom: 'clamp(44px,6vh,72px)' }}>
        <div style={{ fontWeight: 600, fontSize: 14, letterSpacing: '.36em', textTransform: 'uppercase', color: GOLD, marginBottom: 14 }}>IV — The Atelier</div>
        <h2 style={{ fontFamily: "'Bodoni Moda', serif", fontWeight: 500, fontStyle: 'italic', fontSize: 'clamp(38px,5.4vw,74px)', lineHeight: .98, margin: '0 0 22px', color: CREAM }}>Made by hand, for you</h2>
        <p style={{ fontSize: 18, lineHeight: 1.75, color: 'rgba(239,228,210,.72)', margin: 0 }}>
          Every piece is designed as an heirloom first and a garment second — drawn from Mughal-era ornament, old-court silhouettes, and embroidery kept alive by the karigars who still practise it by hand.
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 260px), 1fr))', gap: 'clamp(32px,4vw,64px)' }}>
        {PILLARS.map((p) => (
          <div key={p.n} style={{ borderTop: '1px solid rgba(201,162,75,.28)', paddingTop: 24 }}>
            <div style={{ fontFamily: "'Bodoni Moda', serif", fontSize: 15, color: GOLD_LT, marginBottom: 14 }}>{p.n}</div>
            <h3 style={{ fontFamily: "'Bodoni Moda', serif", fontWeight: 500, fontSize: 'clamp(24px,2.6vw,30px)', lineHeight: 1.1, margin: '0 0 12px', color: CREAM }}>{p.t}</h3>
            <p style={{ fontSize: 16, lineHeight: 1.7, color: 'rgba(239,228,210,.68)', margin: 0 }}>{p.d}</p>
          </div>
        ))}
      </div>

      <div style={{ marginTop: 'clamp(40px,5vh,60px)' }}>
        <Link to="/about" style={{ fontSize: 12, letterSpacing: '.2em', textTransform: 'uppercase', color: GOLD_LT, textDecoration: 'none', borderBottom: '1px solid rgba(226,190,118,.4)', paddingBottom: 6 }}>
          Read our story →
        </Link>
      </div>
    </section>
  );
}
